import {useI18n} from 'store/Store'
import Modal from './Modal'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import {styled, Typography} from '@mui/material'

const DeleteConfirmationModal = ({
    itemName,
    doDelete,
    idToDelete,
    closeDeleteConfirmation,
}) => {
    const {i18n} = useI18n()

    const onDelete = () => {
        doDelete(idToDelete)
        closeDeleteConfirmation()
    }

    return (
        <Modal
            open={!!idToDelete}
            onClose={() => {}}
            buttons={[
                {
                    label: i18n.t('form.cancel'),
                    onClick: closeDeleteConfirmation,
                },
                {
                    label: i18n.t('form.delete'),
                    onClick: onDelete,
                },
            ]}>
            <ModalContent>
                <WarningAmberIcon color="primary" sx={{fontSize: 48}} />
                <Typography variant="subtitle1">
                    {i18n.t('form.deleteConfirmation', {itemName})}
                </Typography>
            </ModalContent>
        </Modal>
    )
}

export default DeleteConfirmationModal

const ModalContent = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
`
